import React, { useEffect, useState } from "react"
import RolesForm from "./form"
import { useLazyGetRoleQuery } from "store/api/roles/roles.api"
import { useParams } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { PERMISSIONS } from "helpers/roles"
import { useSelector } from "react-redux"

const EditRoles = () => {
  const { id } = useParams()
  const [getRole, { isLoading }] = useLazyGetRoleQuery()
  const { permissions } = useSelector((state) => state.user)
  const [roleData, setRoleData] = useState()

  useEffect(() => {
    if (id) {
      const onGetRole = async () => {
        const { data } = await getRole({ id }).unwrap()
        setRoleData({
          name: data.name,
          description: data.description,
          permissions: data.permissions,
        })
      }
      onGetRole()
    }
  }, [id])

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.includes(PERMISSIONS.ROLE_UPDATE)
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Edit Role"} breadcrumbItem={"Edit Role"} />
          {roleData && <RolesForm defaultValues={roleData} id={id} />}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditRoles
